module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('section', [_c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("体检时间")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.physicalDetail.examDate)))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("健康评价")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("formatCharacterInfo")(_vm.physicalDetail.evaluation)))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("健康指导")]), _vm._v(" "), _c('dd', [_vm._v("\n                    " + _vm._s(_vm._f("formatCharacterInfo")(_vm.physicalDetail.guidance)) + "\n                ")])]), _vm._v(" "), _c('dl', {
    staticClass: "field last"
  }, [_c('dt', [_vm._v("危险因素控制")]), _vm._v(" "), _c('dd', [_vm._v("\n                    " + _vm._s(_vm._f("formatCharacterInfo")(_vm.physicalDetail.riskControl)) + "\n                ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bd575fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/healthRecord/PhysicalExamDetail.vue
// module id = 865
// module chunks = 0